<template lang="pug">
  .set-products-sections(:class="{'_child-products--collapsed': isCollapsed && hasMoreProducts}")
    .container
      h2.child-products-header.heading.h2 {{ sectionTitle }}
      .child-products
        .child-products__product(v-for="(childProduct, index) in childProducts")(:class="`set_products`")
          img.child-products__product-image(
            v-if="childProduct.products[0].featured_image"
            v-lazy="childProduct.products[0].featured_image"
            :alt="`${childProduct.products[0].title} Image`"
          )
          img.child-products__product-image(
            v-else
            v-lazy="placeholder"
            alt="Product Placeholder Image"
          )
          .child-products__product-info(:class="`restrict_web_sale_${childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')}`")
            .child-products__product-price-sku
              span.child-products__product-price(v-if="isStudent && !thresholdReached && !childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')") {{ getSudentPrice(childProduct.products[0].tags) ? getSudentPrice(childProduct.products[0].tags) : getRegularPrice(childProduct.products[0].variants[0]) }}
              span.child-products__product-price(v-else-if="isStaff && !childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')") {{ getStaffPrice(childProduct.products[0].tags) ? getStaffPrice(childProduct.products[0].tags) : getRegularPrice(childProduct.products[0].variants[0]) }}
              span.child-products__product-price(v-else-if="isNP && !childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')") {{ getNPPrice(childProduct.products[0].tags) ? getNPPrice(childProduct.products[0].tags) : getRegularPrice(childProduct.products[0].variants[0]) }}
              span.child-products__product-price(v-else-if="!childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')") {{ childProduct.products[0].variants[0].price | money }}
              span.child-products__product-sku SKU# {{ childProduct.products[0].variants[0].sku }}
              span.child-products__product-sku  {{ getMinQtyAboveOne(childProduct.products[0].tags) ? getMinQtyAboveOne(childProduct.products[0].tags) : "" }}
            .child-products__product-title {{ childProduct.products[0].title }}
          .child-proudcts__add-to-cart-form(:id="`product_form_${childProduct.products[0].id}`" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data")
            input(type="hidden" name="form_type" value="product")
            input(type="hidden" name="utf8" value="✓")
            input(type="hidden" name="id" :data-sku="childProduct.products[0].variants[0].sku" :value="childProduct.products[0].variants[0].id")
            input(type="hidden" name="properties[SKU]" :data-sku="childProduct.products[0].variants[0].sku" :value="childProduct.products[0].variants[0].sku")
            input.child-proudcts__quantity-input(name="quantity" v-model.number="quantities[index]" type="number" :min="packSize[index]" :step="packSize[index]" aria-label="Quantity") 
            button(
              v-if="!childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')"
              @click="addToCart(childProduct.products[0].variants[0].id, childProduct, quantities[index], getMinQtyAboveOneCount(childProduct.products[0].tags))"
              :disabled="!childProduct.products[0].variants[0].available || childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')"
              :class="`child-proudcts__add-to-cart-button set_add-to-cart button button--primary set_${[index]}`"
              :data-variant="`${childProduct.products[0].variants[0].id}`")(:data-qty="`${packSize[index]}`"
            ) {{childProduct.products[0].variants[0].available  ? 'Add to Cart' : 'Sold Out'}}
            button(
              v-else
              @click="addToCart(childProduct.products[0].variants[0].id, childProduct)"
              :disabled="!childProduct.products[0].variants[0].available || childProduct.products[0].tags.join(',').toLowerCase().includes('restrict_web_sale')"
              :class="`child-proudcts__add-to-cart-button button button--primary`"
            ) {{childProduct.products[0].variants[0].available  ? 'CALL 800-MACTOOLS' : 'Sold Out'}}
      

</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'SetProductsSection',
    components: {
      Icon,
    },
    props: {
      productData: String,
      placeholder: String,
      setsdata: String,
    },
    data() {
      return {
        sectionTitle: 'Set Includes',
        allChildProducts: [],
        hasMoreProducts: true,
        isCollapsed: true,
        loadNumber: 1000,
        discountLimit: null,
        BVAGlobal: window.__BVA__,
        quantities: [],
        packSize: [],
        quantity: 1
      };
    },
    computed: {
      childProducts () {
        return this.allChildProducts.slice(0, this.loadNumber);
      },
      viewMoreLabel () {
        return !this.isCollapsed ? 'View Less Products' : 'View More Products'
      },
      isMobile () {
        return ['mobile','tablet'].includes(this.$mq);
      },
      isStudent() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          return true;
        }
        return false;
      },
      isStaff() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStaff')){
          return true;
        }
        return false;
      },
      isNP() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:NationalPartner')){
          return true;
        }
        return false;
      },
      thresholdReached() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          if (this.BVAGlobal.customerSpent > this.discountLimit) {
            return true;
          }
        }
        return false;
      },
    },
    mounted() {

      this.$nextTick(() => {

       // console.log('placeholder5', this.setsdata);
        let setArray = this.setsdata.split(',');

        //let childProductsHandles = ['brp12','brp12','brp12','brp12'];

        let childProductsHandles = setArray;



        this.getChildProducts(childProductsHandles);
        this.discountLimitCheck();
        if(childProductsHandles.length <= 10 ){
          this.hasMoreProducts = false;
          this.isCollapsed = false;
        }
       // console.log("productdata",this.childProducts);
        this.quantities = childProductsHandles.map((item) => {
          return 1;
        });
        this.packSize = childProductsHandles.map((item) => {
          return 1;
        });
      });
    },
    methods: {
      hasMinQtyAboveOne(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return true ;
              }
            }
          }
        }
        return false;      
      },
      formatPrice(incomingPrice) {
        let priceValue = incomingPrice / 100
        return priceValue.toLocaleString("en-US", {style:"currency", currency:"USD"});
      },
      getPrice(priceType) {
        for (let i = 0; i < this.selectedVariant.tags.length; i++) {
          if(this.selectedVariant.tags[i].includes(priceType)) {
            return this.selectedVariant.tags[i].split(priceType)[1];
          }
        }
        return false;
      },

      getRegularPrice(variantProduct) {
        let currentVariantProductPrice = variantProduct.price;
        return '$' + (currentVariantProductPrice / 100).toFixed(2);
      },

      getSudentPrice(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('PRICE:STP|') && tags.includes('EP:StudentCanBuy|Y')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('PRICE:STP|')) {
              let priceSTP = parseFloat(childProductTags[i].split('|')[1]);
              if (priceSTP > 0) {
                return "$" + priceSTP;
              }
              else{
                return false;
              }
            }
          }
        }
        return false;      
      },

      getStaffPrice(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('PRICE:STP|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('PRICE:STP|')) {
              let priceSTP = parseFloat(childProductTags[i].split('|')[1]);
              if (priceSTP > 0) {
                return "$" + priceSTP;
              }
              else{
                return false;
              }
            }
          }
        }
        return false;      
      },

      getNPPrice(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('PRICE:NP|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('PRICE:NP|')) {
              let priceNP = parseFloat(childProductTags[i].split('|')[1]);
              if (priceNP > 0) {
                return "$" + priceNP;
              }
              else{
                return false;
              }
            }
          }
        }
        return false;      
      },

      getMinQtyAboveOne(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return "(Min Qty "+qtySuffix+")" ;
              }
            }
          }
        }
        return false;      
      },
      getMinQtyAboveOneCount(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:MinimumQty|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:MinimumQty|')) {
              let qtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (qtySuffix > 1) {
                return qtySuffix;
              }
            }
          }
        }
        return 1;      
      },
      getPackQtyAboveOneCount(childProductTags) {
        let tags = childProductTags.join(',');
        if (tags.includes('EP:PackQty|')) {
          for (let i  = 0; i < childProductTags.length; i++) {
            if (childProductTags[i].includes('EP:PackQty|')) {
              let packQtySuffix = parseInt(childProductTags[i].split('|')[1]);
              if (packQtySuffix > 1) {
                return packQtySuffix;
              }
            }
          }
        }
        return 1;      
      },
      addToCart(variantToAdd, childProduct, qty, minQty) {
        
        let childProductData = childProduct.products[0];
        let scopedThis = this;
        let extraProperties = {};
        let packQtySuffix = 1;


        extraProperties['SKU'] = childProductData.variants[0].sku;
        extraProperties['compare_price'] = childProductData.variants[0].compare_at_price;

        if (this.thresholdReached) {
          extraProperties['STP discount limit exceeded'] = 'Item added at regular price';
        }

        if (this.isStudent) {
        //   extraProperties['_stp_price'] = this.currentPrice;
          extraProperties['_amount_spent'] = parseFloat(this.BVAGlobal.customerSpent);
          extraProperties['_discount_limit'] = this.discountLimit;
        }
        
        for (let i = 0; i < childProductData.tags.length; i++) {
          if (childProductData.tags[i].includes('EP:UpsFreightOverride|')) {
            // split it and add it
            let freightSuffix = childProductData.tags[i].split('|');
            if (freightSuffix.includes('F')) {
              extraProperties['Shipped By'] = 'Freight';
            } else if (freightSuffix.includes('U')) {
              extraProperties['Shipped By'] = 'UPS';
            }
          }
          if (childProductData.tags[i].includes('EP:PackQty|')) {
            packQtySuffix = parseInt(childProductData.tags[i].split('|')[1]);
            if (packQtySuffix > 1) {
              extraProperties['_packSize'] = packQtySuffix;
            }
          }
        }

        if(minQty > 1 && qty < minQty){
          qty = minQty;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            id: variantToAdd,
            //quantity: this.quantity,
            quantity: qty,
            properties: extraProperties,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(function() {
          fetch('/cart.js')
            .then((response) => response.json())
            .then((cartData) => scopedThis.openMiniCart(cartData));
        });

        window.scroll({top: 0, left: 0, behavior: 'smooth'});
      },
      discountLimitCheck() {
        if (this.BVAGlobal.customerTags != null && this.BVAGlobal.customerTags.includes('UserType:STPStudent')){
          let customerTags = this.BVAGlobal.customerTags.join(',');
          if (customerTags.includes('discount_limit:')){
            for (let i = 0; i < this.BVAGlobal.customerTags.length; i++) {
              if (this.BVAGlobal.customerTags[i].includes('discount_limit:')) {
                this.discountLimit = parseInt(this.BVAGlobal.customerTags[i].split(':')[1]);
              }
            }
          }
        }
      },
      getChildProducts(childProductsHandles){
        let count = 0;
        childProductsHandles.forEach((handle, index) => {
          if (handle !== '') {
            let fetchURL = '/search?type=product&q=variants.sku:' + handle + '&view=sku';
            fetch(fetchURL)
              .then((response) => response.json())
              .then((prodData) => {
                if (prodData.products.length > 0) {
                  this.allChildProducts.push(prodData);
                  //console.log("index",index, prodData);
                  this.quantities[count]=this.getMinQtyAboveOneCount(prodData.products[0].tags);
                  this.packSize[count]=this.getPackQtyAboveOneCount(prodData.products[0].tags);
                  count++;
                  
                }

              });
          }
        });
      },
      hasRestrictWebSale(childProductData) {
        /*let tags = this.childProductData.tags.join(',');
        if (tags.includes('Restrict_web_sale') || tags.includes('restrict_web_sale')) {
            return true;
        }
        return false;*/
          for (let i = 0; i < childProductData.tags.length; i++) {
            if (childProductData.tags[i].includes('Restrict_web_sale')) {
              return true;            
            }
          }
        return false;
      },
      hasMoreProductsProducts(){ 
                //  console.log("allproductlength",this.allChildProducts.length,this.quantities.length);

        if(this.loadNumber <= this.allChildProducts.length){
          this.loadNumber += 10;
        } else {
          this.isCollapsed = !this.isCollapsed;
        }
      },
      formatPrice(incomingPrice) {
        let priceValue = incomingPrice / 100
        return priceValue.toLocaleString("en-US", {style:"currency", currency:"USD"});
      },
      openMiniCart(cartData) {
        this.productInCart = true;
        let cartContainer = document.querySelector('#mini-cart');
        let cartHTML = "";
        let totalSavings = 0;
        if (cartData.items.length > 0) {
          cartHTML += `
            <div class="mini-cart__inner">
              <div class="mini-cart__content">
                <div class="mini-cart__line-item-list">
          `;
          for (let i = 0; i < cartData.items.length; i++) {
            let lineItem = cartData.items[i];
            let priceHTML = "";
            let propertiesHTML = "";
            let comparePrice = 0;
            for (const [key, value] of Object.entries(lineItem.properties)) {
              if (key == 'compare_price') {
                comparePrice = value;
              } else if (key == 'Shipped By' || key == 'STP discount limit exceeded' || key == 'SKU') {
                propertiesHTML += `
                  <li class="mini-cart__property"><strong>${key}</strong>: ${value}</li>
                `;
              }
            }
            if (lineItem.price < comparePrice) {
              priceHTML = `
                <span class="price price--highlight">${this.formatPrice(lineItem.final_line_price)}</span>
                <span class="price price--compare">${this.formatPrice(comparePrice * lineItem.quantity)}</span>
              `;
              totalSavings += ((comparePrice - lineItem.price) * lineItem.quantity);
            } else {
              priceHTML = `
                <span class="price price--highlight">${this.formatPrice(lineItem.final_line_price)}</span>
              `;
            }
            let imageHTML = '';
            if (lineItem.image) {
              imageHTML = `<img src="${lineItem.image}" alt="${lineItem.title}">`
            } else {
              imageHTML = `<img src="${lineItem.image}" style='opacity: 0;' alt="${lineItem.title}">`
            }
            let lineItemHTML = `
              <div class="mini-cart__line-item var_${lineItem.id}">
                <div class="mini-cart__image-wrapper">
                  <div class="aspect-ratio" style="padding-bottom: 100.0%">
                    ${imageHTML}
                  </div>
                </div>
                <div class="mini-cart__item-wrapper">
                  <div class="mini-cart__product-info">
                    <a href="/products/${lineItem.handle}?variant=${lineItem.id}" class="mini-cart__product-title text--strong link">${lineItem.title}</a>
                    <ul class="mini-cart__property-list" role="list">
                      ${propertiesHTML}
                    </ul>
                    <div class="mini-cart__price-list">
                      ${priceHTML}
                    </div>
                  </div>
                  <div class="mini-cart__quantity">
                    <div class="quantity-selector">
                      <button class="quantity-selector__button" data-action="decrease-quantity" data-quantity="${lineItem.quantity - 1}" data-line="${i + 1}" aria-label="Decrease quantity" title="Decrease quantity">
                        <svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2" role="graphics-symbol">
                          <path d="M10 0v2H0V0z" fill="currentColor"></path>
                        </svg>
                      </button>
                      <input aria-label="Quantity" class="quantity-selector__value" inputmode="numeric" data-current-value="${lineItem.quantity}" data-line="${i + 1}" value="${lineItem.quantity}" size="2">
                      <button class="quantity-selector__button" data-action="increase-quantity" data-quantity="${lineItem.quantity + 1}" data-line="${i + 1}" aria-label="Increase quantity" title="Increase quantity">
                        <svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10" role="graphics-symbol">
                          <path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                    <a href="/cart/change?quantity=0&amp;line=1" data-action="decrease-quantity" data-quantity="0" data-line="${i + 1}" class="mini-cart__quantity-remove link">Remove</a>
                  </div>
                </div>
              </div>
            `;
            cartHTML += lineItemHTML;
          }

          let savingsHTML = '';
          if(totalSavings > 0) {
            savingsHTML = `<span class="mini-cart__amount-saved">You saved <span>${this.formatPrice(totalSavings)}</span>!</span>`
          }
          cartHTML += `
                </div>
                <div class="mini-cart__recap">
                  <div class="mini-cart__recap-price-line">
                    <span>Total</span>
                    <span>&nbsp;${this.formatPrice(cartData.total_price)}</span>
                  </div>
                  ${savingsHTML}
                  <div class="mini-cart__button-container">
                    <div class="button-group button-group--loose button-group--fit">
                      <a href="/cart" class="button button--secondary">View cart</a>
                      <button type="submit" name="checkout" class="button button--primary">Checkout</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          `;
        } else {
          cartHTML = `
            <div class="mini-cart__content mini-cart__content--empty">
              <div class="mini-cart__empty-state">
                <svg focusable="false" width="81" height="70" viewBox="0 0 81 70">
                  <g transform="translate(0 2)" stroke-width="4" stroke="#1e2d7d" fill="none" fill-rule="evenodd">
                    <circle stroke-linecap="square" cx="34" cy="60" r="6"></circle>
                    <circle stroke-linecap="square" cx="67" cy="60" r="6"></circle>
                    <path d="M22.9360352 15h54.8070373l-4.3391876 30H30.3387146L19.6676025 0H.99560547"></path>
                  </g>
                </svg>
                <p class="heading h4">Your cart is empty</p>
              </div>
              <a href="/collections/all" class="button button--primary button--full">Shop our products</a>
            </div>
          `;
        }

        //cartContainer.innerHTML = cartHTML;
        //document.querySelector('.header__cart-count').innerHTML = cartData.item_count;
        //document.querySelector('.header__cart-toggle').click();

        setTimeout(function(){ 
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
              quantity: 1
            }
          }));
        }, 500);


      },
    }
  }
</script>

<style scoped lang="scss">
 .set-products-section {  }
</style>
